import React from "react";

import asIcon from "./asIcon";

export default asIcon(({ color }) => (
  <path fill={color} d="M50 13.9c6.6 0 12 6.1 12 13.5s-5.4 13.5-12 13.5-12-6-12-13.5 5.4-13.5 12-13.5m0-8c-11 0-20 9.6-20 21.5s9 21.5 20 21.5 20-9.6 20-21.5S61 5.9 50 5.9zm7.5 55.5c9.1 0 17 8.4 17 18 0 .9 0 3-6 4.6l-2.5.5A101.8 101.8 0 0 1 49.1 86h-4.8a65.8 65.8 0 0 1-10.5-1.4l-1-.2c-1.6-.3-4.9-1.1-5.8-1.8a4.1 4.1 0 0 1-1.4-3c0-9.6 7.9-18 17-18h15m0-8h-15a26 26 0 0 0-25 26 12.1 12.1 0 0 0 4.3 9.2c2.6 2.2 6.9 3 10.2 3.7a73.5 73.5 0 0 0 11.8 1.6l5.4.2a109.5 109.5 0 0 0 18.2-1.6l3.2-.7c6.2-1.6 11.9-5.1 11.9-12.3 0-13.8-11.2-26-25-26z" />
));
